import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as filteringActions from '@app/filtering/state/filtering.actions';
import { map, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsQuery } from '@app/shared/analytics-query.model';
import { Facet, Facets } from '@wam/shared';

@Injectable()
export class FilteringEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  updateSelected$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(filteringActions.updateSelected),
        tap(({ selected, ignoreChange }) => {
          if (!ignoreChange) {
            let queryParams = AnalyticsQuery.fromFacets(selected);
            if (queryParams?.query?.length === 0) {
              queryParams = { query: null };
            }
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams,
              queryParamsHandling: 'merge',
            });
          }
        }),
      ),
    { dispatch: false },
  );

  updateFacets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(filteringActions.updateFacets),
      map(({ facets, selected }) => {
        if (selected) {
          return filteringActions.updateSelected({
            selected,
            ignoreChange: true,
          });
        }

        const fromQuery: Facets = AnalyticsQuery.fromQuery(
          new AnalyticsQuery(this.route.snapshot.queryParams.query),
        );
        return filteringActions.updateSelected({
          selected: this.facetDifference(facets, fromQuery),
          ignoreChange: true,
        });
      }),
    ),
  );

  private facetDifference(facets: Facets, selected: Facets): Facets {
    const difference: Facets = {};
    Object.keys(selected).forEach((key) => {
      const matchingFacets =
        selected[key]?.filter((facet: Facet) => {
          return facets[key].some((selectedFacet) => selectedFacet.value === facet.value);
        }) ?? [];
      if (matchingFacets.length) {
        difference[key] = matchingFacets;
      }
    });
    return difference;
  }
}
